module.exports = __webpack_public_path__ + "static/media/12_Bild_3_ARM_Team-Imperial_AlessandroDellaBella_083.1ae92dae.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle12/12_Bild_3_ARM_Team-Imperial_AlessandroDellaBella_083.jpg
 ** module id = 150
 ** module chunks = 0
 **/